module.exports = __webpack_public_path__ + "img/png.da8970ee.png";